import React from 'react';
import './style.scss';
import { API_NftDetails, NftTrait } from 'shared';
import clsx from 'clsx';
import MarketPageDescBlock from './block';
import MarketPageActionHint from '../actionHint';
import { MarketNftStatuses } from '../Interfaces';

interface Props {
  nft: API_NftDetails;
  status: MarketNftStatuses;
  className?: string;
  loading: boolean;
  includeHint?: boolean;
  disableTraits?: boolean;
}

const MarketNftDescription = ({
  nft,
  status,
  className,
  loading,
  includeHint = false,
  disableTraits = false
}: Props) => (
  <div className={className}>
    <div
      className={clsx('market-nft-desc', loading && 'market-nft-desc-loading')}
    >
      <MarketPageDescBlock
        title='name'
        value={nft.name}
        className='market-nft-desc-block'
      />
      <div className='market-nft-desc-line'>
        <MarketPageDescBlock
          title='clan'
          value={nft.guild}
          className='market-nft-desc-block'
        />
        {includeHint && (
          <MarketPageActionHint
            status={status}
            price={nft.price}
            className='market-nft-desc-block'
          />
        )}
      </div>
      {!disableTraits && (
        <div className='market-nft-desc-traits'>
          {nft.traits.map((trait, index) => (
            <TraitBlock trait={trait} key={index} />
          ))}
        </div>
      )}
    </div>
  </div>
);

interface TraitProps {
  trait: NftTrait;
}

const TraitBlock = ({ trait }: TraitProps) => (
  <div className='market-nft-desc-trait'>
    <p>{trait.traitType}</p>
    <h5>{trait.value}</h5>
  </div>
);

export default MarketNftDescription;
